import React, { useState, useEffect } from 'react';
import { Button, CircularProgress } from '@material-ui/core'
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { useSelector } from 'react-redux';
import { postData, postDataBlob } from '../../functions/postData.js';
import { makeStyles } from '@material-ui/core/styles';
import { TbFileCertificate } from "react-icons/tb";
import Icon from '@mdi/react';
import { mdiListStatus, mdiFormatListCheckbox  } from '@mdi/js';
import { _ } from '../../functions/translator.js';

function ExportButton (props) {
    const [loading, setLoading] = useState(false);
    const [showSuccesToast, setShowSuccessToast] = useState(false);
    const [showFailureToast, setShowFailureToast] = useState(false);

    const {visibleCardsGroupIds, selectedCardsGroups, projectData} = useSelector(state => ({
        visibleCardsGroupIds: state.visibleCardsGroupIds,
        selectedCardsGroups: state.selectedCardsGroups,
        projectData: state.projectData
    }))

    const searchParams = new URLSearchParams(window.location.search);
    const project_id = searchParams.get('project_id');

    let cardsGroupsSelectedObservations = 0
    if (selectedCardsGroups !== "none") {
        for (let i = 0; i < selectedCardsGroups.length; i++) {
            const cardGroupId = selectedCardsGroups[i];
            
            const cardGroup = projectData.cards_groups[cardGroupId];

            if (!cardGroup) continue
            
            if (cardGroup.attributes.status === "closed" || 
                cardGroup.attributes.status === "in progress" || 
                cardGroup.attributes.status === "with no conformities") {
                
                const isCustomCardActivated = projectData.customcards[cardGroup.attributes.customcard_id].attributes.protocol_id;

                if (isCustomCardActivated !== null) {
                    cardsGroupsSelectedObservations++;
                }
            }
        }
    }


    const useStyles = makeStyles((theme) => ({
        root: {
          display: 'flex',
          '& > * + *': {
            marginLeft: theme.spacing(2),
          },
        },
      }));

    const classes = useStyles();

    const handleClick = async() => {
        setLoading(true)
        try {
            const urlPost = props.certificates?{
                project_id,
                cards_group_ids: selectedCardsGroups === "none"? visibleCardsGroupIds : selectedCardsGroups,
                group_by: props.certificates.groupby,
                merge_pdf: props.certificates.merge_pdf,
                manual_signatures_charges: props.certificates.manualSignaturesCharges,
                with_images: props.certificates.withImages,
            }:{
                project_id,
                cards_group_ids: selectedCardsGroups === "none"? visibleCardsGroupIds : selectedCardsGroups
            }
            
            if (props.postData === "postDataBlob"){
                const response = await postDataBlob(`/${props.endpoint}`, urlPost, 'Error en la solicitud')
                if (response) {
                    const newBlobUrl = window.URL.createObjectURL(response)
                    const link = document.createElement('a');
                    link.href = newBlobUrl;
                    link.download = `${props.name}.xlsx`;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    setShowSuccessToast(true)
                } else {
                    setShowFailureToast(true)
                }
                if(props.onStateToastChange){
                    props.onStateToastChange(false,response)
                }
            } else if(props.postData === "postData") {
                const response = await postData(`/${props.endpoint}`, urlPost, 'Error en la solicitud')

                if (response) {
                    setShowSuccessToast(true)
                } else {
                    setShowFailureToast(true)
                }
                if(props.onStateToastChange){
                    props.onStateToastChange(false,response)
                }
            }
        } catch (error) {
            console.error('Error:', error)
        } finally {
            setLoading(false);
        }
    }

    let disabledButton = false
    

    useEffect(() => {
        // Notify the parent component about the button status
        props.onStateChange && props.onStateChange(disabledButton);
    }, [disabledButton]);

    if(props.popUpMenu && props.name === "Observaciones" && cardsGroupsSelectedObservations === 0){
        disabledButton = true
    }
    if(props.popUpMenu && props.name === "Registros" && selectedCardsGroups.length === 0){
        disabledButton = true
    }

    let backgroundColor = '#ff5300'
    let opacityButton = 1

    if(props.popUpMenu){
        backgroundColor = ''
        if (disabledButton){
            opacityButton = 0.3
        }
    }

    return (
        <>
            <Snackbar className='w-100 p-0' onClose={() => setShowSuccessToast(false)} open={showSuccesToast} autoHideDuration={4000}>
                <MuiAlert elevation={6} variant="filled" severity="success">
                    {props.name === "Certificados"? 
                    <p className='text-center w-100 m-0'>
                        {_('Estamos preparando los certificados. Te enviaremos un link a tu correo cuando la descarga esté lista')}.
                    </p>
                    : 
                    <p className='text-center w-100 m-0'>
                        ¡{_(`Se han exportado ${props.name} correctamente`)}!
                    </p>}
                </MuiAlert>
            </Snackbar>
            <Snackbar className='w-100 p-0' onClose={() => setShowFailureToast(false)} open={showFailureToast} autoHideDuration={4000}>
                <MuiAlert elevation={6} variant="filled" severity="error">
                    <p className='text-center w-100 m-0'>
                        ¡{_('Ha ocurrido un error al exportar')} {_(props.name)}!
                    </p>
                </MuiAlert>
            </Snackbar>
            <Button 
                onClick={handleClick} 
                disabled={loading || disabledButton || props.disabled} 
                size='small' 
                style={{width:'100%', height:'100%', background: props.disabled ? '#ff9057' : backgroundColor, color:"#ffffff", textTransform: 'none', fontWeight:700, marginBottom:'10px', opacity: opacityButton}}
                data-toggle="tooltip" data-placement="top" title={`${_('La extensión de este archivo es')} ${props.ext}`}
            >
            <div className={`w-100 d-flex flex-row align-items-center`}>
                {props.name === "Registros" ? (
                    <div style={{width:'25px', position:'relative', top:'-2px'}} ><Icon path={mdiFormatListCheckbox } size={1} /></div>
                ) : props.name === "Certificados" ? (
                    <div style={{width:'25px', position:'relative', top:'-2px', marginRight:'2.5px'}}><TbFileCertificate size={20}/></div>
                ) : props.name === "Observaciones" ? (
                    <div style={{width:'25px', position:'relative', top:'-2px', }}><Icon path={mdiListStatus} size={1} /></div>
                ) : (
                    null
                )}
                <div className='w-100 m-0 ml-1 d-flex justify-content-start align-items-center flex-column'>
                    <p className='m-0 d-flex align-items-end' style={{fontFamily:'Rubik'}}>
                        {_('Exportar')} {_(props.name)}
                    </p>
                    <p className='m-0 d-flex align-items-end' style={{fontFamily:'Rubik'}}>
                        {(props.name === "Observaciones" && props.popUpMenu === true) && 
                            ` (${_('A partir de')} ${cardsGroupsSelectedObservations} ${_('disponibles')})`
                        }
                    </p>
                    <p className='m-0 d-flex align-items-end' style={{fontFamily:'Rubik'}}> 
                        {(props.name === "Registros" && props.popUpMenu === true) && (
                            ` (${selectedCardsGroups.length} ${_('disponibles')})`
                        )}
                    </p>
                </div>
                
                <div className={classes.root}>
                    <div style={{width:'20px', height:'20px'}} className={loading && 'd-none'}></div>
                </div>
                {loading && 
                <div className={classes.root}>
                    <CircularProgress style={{width:'20px', height:'20px'}} />
                </div>}
                
            </div>
            </Button>
        </>
    )
}

export default ExportButton;